






























import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Element } from "@api/models/Element";
import EventEditPartner from "@share/event-edit/components/EventEditPartner.vue";
import { Debounce } from "vue-debounce-decorator";
import { ArrayHelpers } from "@common/ArrayHelpers";

@Component({
    name: "EventEditPartners",
    components: { EventEditPartner }
})
export default class EventEditPartners extends Vue {
    @Prop({ default: () => [] }) selectedPartnersIds: string[];
    @Prop({default: false}) hasStageFile: boolean;

    showArrows = false;

    handleDragStart(e: DragEvent, index: string): void {
        const target = this.getTarget(e);

        target && (target.style.opacity = '0.4');

        if(e.dataTransfer) {
            e.dataTransfer.effectAllowed = 'move';
            e.dataTransfer.setData('data', index.toString());
        }
    }

    handleDragEnd(e: DragEvent) {
        const target = this.getTarget(e);

        if(target) {
            target.style.opacity = '1';

            const items = Array.from(target.parentElement?.children || [])

            items.forEach((item) => {
                item.classList.remove('over');
            });
        }

    }

    handleDragEnter(e: DragEvent) {
        const target = this.getTarget(e);
        if(target) {
            target?.classList.add('over');
        }
    }

    handleDragLeave(e: DragEvent) {
        const target = this.getTarget(e);
        if(target) {
            target.classList.remove('over');
        }
    }

    handleDragOver(e: DragEvent) {
        if (e.preventDefault) {
            e.preventDefault();
        }

        return false;
    }

    handleDrop(e: DragEvent, toId: string) {
        e.stopPropagation();

        if(e.dataTransfer) {

            const sourceId = e.dataTransfer.getData('data');

            const fromIindex = this.selectedPartnersIds.findIndex((partnerId) => partnerId === sourceId);

            if(fromIindex >= 0) {

                let toIndex = this.selectedPartnersIds.findIndex((partnerId) => partnerId === toId);

                if(toIndex < 0) {
                    toIndex = this.selectedPartnersIds.length - 1;
                }

                //changing ordering in exhibition list
                ArrayHelpers.moveInArray(this.selectedPartnersIds, fromIindex, toIndex);
            }
        }
        return false;
    }

    private getTarget(e: Event): HTMLElement | null {
        if(e.target && e.target instanceof HTMLElement) {
            return e.target
        }

        return null
    }

    get partners(): Element[] {
        const exhibitions = this.exhibitionsList;

        const rootList = Object.values(exhibitions).filter(item => item.parentId != null);

        const selectedPartnersList = this.selectedPartnersIds
            .map(selectedPartnerId => rootList.find(partner => selectedPartnerId === partner.id) as Element)
            .filter(i => i);

        const restPartnersList = rootList.filter(partner => !this.selectedPartnersIds.includes(partner.id))

        return selectedPartnersList.concat(restPartnersList);
    }

    get exhibitionsList(): Record<string, Element> {
        return this.$store.getters['events/selectedEventExhibitions'] as Record<string, Element>;
    }

    get selectedEventId() {
        return this.$store.state.events.selected;
    }

    get partnersWidth() {
        if (this.$refs['partners']) {
           const computedStyles = getComputedStyle((this.$refs['partners'] as Array<Vue>)[0].$el);
           return parseInt(computedStyles.width) + parseInt(computedStyles.marginRight)
        }
        return 0;
    }

    @Watch('partners')
    onPartnersChange() {
        this.setShowArrows();
    }

    mounted() {
        this.setShowArrows();
        window.addEventListener('resize', this.setShowArrows);
    }

    @Debounce(300)
    setShowArrows() {
        if (this.$refs['container']) {
            const container = (this.$refs['container'] as HTMLElement);

            this.showArrows = container.clientWidth < container.scrollWidth;
        }

        return this.showArrows;
    }

    onWheel(event: WheelEvent) {
        event.preventDefault();
        if (this.$refs['container']) {
            (this.$refs['container'] as HTMLElement).scrollLeft += (event.deltaY + event.deltaX);
        }
    }

    onMoveLeft() {
        const container = this.$refs['container'] as HTMLElement;
        if (container.scrollLeft == 0) { return; }

        container.scrollTo({
            left: Math.round((container.scrollLeft - container.clientWidth) / this.partnersWidth) * this.partnersWidth,
            behavior: 'smooth'
        });
    }

    onMoveRight() {
        const container = this.$refs['container'] as HTMLElement;

        container.scrollTo({
            left: Math.round((container.scrollLeft + container.clientWidth) / this.partnersWidth) * this.partnersWidth,
            behavior: 'smooth'
        });
    }

    beforeDestroy() {
        window.removeEventListener('resize', this.setShowArrows);
    }
}
